import LayoutPadrao from '../layouts/LayoutPadrao.vue'
import campanhaMarketingView from '@/views/campanhas-marketing/CampanhaMarketingUnificada.vue'
import smsListaView from '@/views/campanhas-marketing/SmsListaView.vue'

// Auth check function
const isAuthenticated = (to, from, next) => {
  const isLoggedIn = localStorage.getItem('user') !== null
  if (isLoggedIn) next()
  else next('/login')
}

export default {
  path: '/',
  component: LayoutPadrao,
  beforeEnter: isAuthenticated,
  children: [
    {
      path: 'campanha-marketing',
      name: 'enviar-campanha-marketing',
      component: campanhaMarketingView,
      meta: {
        requiresAuth: true,
        title: 'Enviar Campanha Marketing',
        nome_fisico: 'enviar-campanha-marketing'
      },
    },
    // Rotas legadas redirecionam para a nova rota unificada
    {
      path: 'push-marketing',
      redirect: { name: 'enviar-campanha-marketing' }
    },
    {
      path: 'whatsapp-marketing',
      redirect: { name: 'enviar-campanha-marketing' }
    },
    {
      path: 'sms-marketing',
      redirect: { name: 'enviar-campanha-marketing' }
    },
    {
      path: 'sms-marketing-lista',
      name: 'listar-sms-cliente',
      component: smsListaView,
      meta: {
        requiresAuth: true,
        title: 'Campanhas SMS',
        nome_fisico: 'listar-sms-cliente'
      },
    }
  ],
}
